<template>
  <div
    class="page"
    :class="{ setHeight: !loginIsShow, setHeight2: userInfoIsShow }"
  >
    <div
      class="loginDialog"
      :class="{ setHeight: !loginIsShow, setHeight2: userInfoIsShow }"
    >
      <iframe
        :class="{ setHeight: !loginIsShow, setHeight2: userInfoIsShow }"
        style="width: 100vw; height: 100vh"
        :src="`https://${env}static.zhibo.tv/publicmodule/pcheader`"
        frameborder="0"
        id="iframe"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      // 是否展示登录弹窗
      loginIsShow: false,
      // 是否展示右上角用户信息(hover头像后)
      userInfoIsShow: false,
      env:process.env.VUE_APP_BASE
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    window.addEventListener('message', (event) => {
      // 收到通知需要刷新
      if (event.data.command === 'reload') {
        console.log('收到通知需要刷新')
        window.location.reload()
      }
      // 收到通知登录弹窗已展示
      if (event.data.command === 'loginIsShow') {
        console.log('收到通知登录弹窗已展示')
        this.loginIsShow = true
      }
      // 收到通知登录状态下hover用户信息已展示
      if (event.data.command === 'userInfoIsShow') {
        console.log('收到通知登录状态下hover用户信息已展示')
        this.userInfoIsShow = event.data.visible
      }
      // 收到通知退出登录,需要清除session
      if (event.data.command === 'loginout') {
        console.log('收到通知退出登录,需要清除session')
        sessionStorage.removeItem('userToken')
        sessionStorage.removeItem('userPoints')
      }
      // 收到通知处理三方登录
      if (event.data.command === 'thirdLogin') {
        const type = Number(event.data.type)
        console.log('收到通知处理三方登录', type)
        if (type === 4) {
          window.location.href =
            'https://graph.qq.com/oauth2.0/authorize?client_id=101240358&response_type=token&scope=all&redirect_uri=https%3A%2F%2Fwww.zhibo.tv%2Findex%2Flogincallback'
        } else if (type === 3) {
          window.location.href =
            'https://open.weixin.qq.com/connect/qrconnect?appid=wx8b69092513ae89a8&redirect_uri=http%3A%2F%2Fwww.zhibo.tv%2Findex%2Flogincallback&response_type=code&scope=snsapi_login&state=cDU5V2#wechat_redirect'
        } else if (type === 5) {
          // 微博新回调（流程已通）
          window.location.href =
            'https://api.weibo.com/oauth2/authorize?client_id=2041833082&response_type=code&redirect_uri=https://t100-static.zhibo.tv/publicmodule/callback'
        }
      }
    })
    setTimeout(() => {
      const url = window.location.href
      document
        .getElementById('iframe')
        .contentWindow.postMessage({ command: 'parentUrl', url })
        console.log('父页面url',url);
    }, 2000)
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 3;
}
.loginDialog {
  height: 100vh;
}
.setHeight {
  height: 72px !important;
}
.setHeight2 {
  height: 270px !important;
}
</style>
